import { Link } from "react-router-dom"
import { useBranding } from "@/config/context"

/** Brand mark + name, both taken from the configuration. */
export function Brand({ compact = false }: { compact?: boolean }) {
  const branding = useBranding()
  return (
    <Link to="/" className={`brand ${compact ? "brand-compact" : ""}`} aria-label={`${branding.name} home`}>
      <img className="brand-logo" src={branding.logo} alt="" width={28} height={28} />
      {!compact && <span className="brand-name">{branding.shortName}</span>}
    </Link>
  )
}
